// extracted by mini-css-extract-plugin
var _1 = "PasswordTips_root__b98a6";
var _2 = "PasswordTips_rule__0931d";
export { _1 as "root", _2 as "rule" }
